import React from 'react';
import styled from 'styled-components';
import { Icon } from './_base';

const InsuranceInNetworkBadgeSVG = styled(Icon).attrs({
    viewBox: '0 0 31 35',
})``;

const InsuranceInNetworkBadge = props => (
    <InsuranceInNetworkBadgeSVG
        data-test={'insurance-in-network-badge'}
        xmlns={'http://www.w3.org/2000/svg'}
        {...props}
    >
        <path
            opacity=".12"
            d="M15.5 1.813C11.086 5.426 3.946 6.186 2.067 6.28c-.282 0-.47.286-.47.57.47 22.723 11.274 27.097 13.717 27.762.282.095.657.095.94 0 2.442-.665 13.246-4.944 13.998-27.571 0-.285-.188-.57-.47-.57-1.973-.19-9.02-.951-13.34-4.66-.377-.19-.658-.19-.94 0z"
            fill="#000"
        />
        <path
            d="M14.748.48C10.238 4.095 3.193 4.855 1.22 4.95c-.282 0-.47.284-.47.57.47 22.722 11.274 27.096 13.717 27.761.281.095.657.095.94 0 2.442-.665 13.246-4.944 13.997-27.571 0-.285-.187-.57-.47-.57-1.972-.19-9.018-.951-13.34-4.66-.282-.284-.658-.284-.846 0z"
            fill="#00D19F"
        />
        <path
            d="M14.749 3.524C11.179 6.471 5.448 7.042 3.85 7.232c-.282 0-.47.19-.47.38.376 18.445 9.113 22.057 11.086 22.628.282.095.564.095.752 0 1.973-.57 10.71-3.993 11.368-22.438 0-.285-.188-.475-.376-.475-1.597-.095-7.328-.76-10.898-3.803-.094-.19-.376-.19-.564 0z"
            fill="#00E6AF"
        />
        <path
            d="M10.917 21.042l1.965 1.77 8.868-10.087-1.966-1.77-8.867 10.087z"
            fill="#fff"
        />
        <path
            d="M12.86 22.733l1.75-1.989-4.423-3.981-1.748 1.989 4.422 3.981z"
            fill="#fff"
        />
    </InsuranceInNetworkBadgeSVG>
);

export { InsuranceInNetworkBadge as default, InsuranceInNetworkBadge };
